import { acpSecureUploadStates } from './states';

export default (appModule) => {
  appModule.config(acpSecureUploadStates);
};
